export default {
    control: (base) => ({
        ...base,
        minHeight: '46px',
        height: '100%'
    }),
    indicatorContainer: (base) => ({
        ...base,
        padding: '2px'
    }),
    indicatorSeparator: (base) => ({
        ...base,
        display: 'none' as 'none'
    })
};